export const ZOOM_SUPPORTED = false;

export function ZoomChecker() {
  // Does nothing by default
  return null;
}
